import * as ng from 'angular';
import { UISelectService } from '../../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import { Object } from 'es6-shim';
import { diff } from 'deep-object-diff';
import { IListini } from '../../../../../commons/interfaces/listini';

class CreaListinoController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      listino: IListini
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService
  ) {
    $scope.pageHeader = 'Crea Listino Archismall';
    $scope.pageSubHeader = '';
    $rootScope.formsubmitted = false;

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.openConfermaModal = (size) => {
      console.log($scope.listino);

      // fare modal per conferma o altro vedi poi
      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'listiniComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          listino: () => {
            return $scope.listino;
          },
        }
      });

    };

  }
}

export const CreaListinoComponent: ng.IComponentOptions = {
  template: require('./crea-listino.html'),
  controller: CreaListinoController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/crea-listino/crea-listino.ts